import { services } from '@/shared/plugins/services';

const time = services.resolve('time');

const epgTime = {
  dayOffset: 0,
  now: time.now,
  updateIntervalId: 0,
  get today() {
    return time.now.startOf('day').add(this.dayOffset, 'd').clone();
  },
  updateWithInterval(interval = 1000) {
    this.updateIntervalId = setInterval(() => {
      time.emit('sync');
    }, interval);
  },

  stopUpdate() {
    clearInterval(this.updateIntervalId);
  },

  dates: {
    range: {
      min: -6,
      max: 6,
    },
    get current() {
      return this.list.find((el) => {
        return epgTime.dayOffset === el.offset;
      });
    },
    get list() {
      const day = time.now.startOf('day');
      day.add(this.range.min - 1, 'd');
      const days = [];
      for (let i = this.range.min; i <= this.range.max; i++) {
        days.push({
          offset: i,
          date: day.add(1, 'd').clone(),
        });
      }
      return days;
    },
  },
  get hours() {
    const hours = [];

    for (let i = 0; i < 24; i++) {
      hours.push(('00' + i).substr(-2, 2) + ':00');
    }

    return hours;
  },
};

time.on('sync', () => {
  epgTime.now = time.now;
});

export default epgTime;
